import React, { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Loader2, ArrowRight, Link2 } from "lucide-react";

export default function ShortenForm({ onCreated, isDemo = false }) {
  const [url, setUrl] = useState("");
  const [customSlug, setCustomSlug] = useState("");
  const [loading, setLoading] = useState(false);
  const [showAdvanced, setShowAdvanced] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!url) return;
    setLoading(true);
    try {
      const { data } = await api.post("/api/links", {
        long_url: url,
        custom_slug: customSlug || undefined,
      });
      toast.success(isDemo ? "Demo link created (expires in 7 days)" : "Short link created");
      setUrl("");
      setCustomSlug("");
      onCreated?.(data);
    } catch (err) {
      const detail = err?.response?.data?.detail || "Failed to shorten";
      toast.error(detail);
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={submit} className="w-full" data-testid="shorten-form">
      <div className="flex flex-col md:flex-row gap-0 border-2 border-foreground bg-background">
        <div className="flex items-center px-4 border-r-0 md:border-r border-foreground">
          <Link2 className="w-5 h-5 opacity-40" />
        </div>
        <input
          data-testid="shorten-url-input"
          type="url"
          required
          placeholder="https://your-very-long-url.com/goes/here"
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          className="flex-1 px-5 py-4 md:py-5 bg-transparent focus:outline-none font-mono text-sm md:text-base placeholder:text-muted-foreground/50"
        />
        <button
          data-testid="shorten-url-btn"
          type="submit"
          disabled={loading}
          className="px-6 py-4 md:py-5 bg-foreground text-background hover:bg-foreground/90 font-medium text-sm flex items-center justify-center gap-2 disabled:opacity-50"
        >
          {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <ArrowRight className="w-4 h-4" />}
          Shorten
        </button>
      </div>

      {!isDemo && (
        <div className="mt-3 flex items-center gap-3 text-xs">
          <button
            type="button"
            onClick={() => setShowAdvanced((v) => !v)}
            data-testid="shorten-toggle-advanced"
            className="text-muted-foreground hover:text-foreground transition-colors underline-offset-4 hover:underline"
          >
            {showAdvanced ? "Hide" : "Show"} custom alias
          </button>
        </div>
      )}
      {showAdvanced && !isDemo && (
        <div className="mt-3 flex items-center gap-0 border border-border">
          <span className="px-3 py-2 text-xs text-muted-foreground font-mono border-r border-border">splink.pro/</span>
          <input
            data-testid="shorten-custom-slug"
            value={customSlug}
            onChange={(e) => setCustomSlug(e.target.value)}
            placeholder="my-brand"
            className="flex-1 px-3 py-2 text-sm bg-transparent focus:outline-none font-mono"
          />
        </div>
      )}
    </form>
  );
}
